module.exports = __webpack_public_path__ + "img/kjjh_gallery2.4dc7ecba.jpg";